var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.image !== ""
    ? _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.fullscreen.lock",
              value: _vm.pageLoad,
              expression: "pageLoad",
              modifiers: { fullscreen: true, lock: true }
            }
          ],
          class: ["login-container", _vm.pageLoad ? "loading" : "loaded"],
          style: {
            "background-image": "url(" + _vm.image + ")",
            "background-size": "cover",
            height: "100vh",
            width: "100vw",
            overflow: "hidden"
          },
          attrs: { id: "container" }
        },
        [
          _c(
            "div",
            {
              class: _vm.isAdmin ? "login-card altered" : "login-card unaltered"
            },
            [
              _c(
                "el-form",
                {
                  ref: "loginForm",
                  staticClass: "login-form",
                  attrs: {
                    model: _vm.loginForm,
                    rules: _vm.loginRules,
                    autocomplete: "on",
                    "label-position": "left"
                  }
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "title-container" },
                      [
                        (!_vm.isMerchant && _vm.logo.logoPath !== "") ||
                        _vm.fetchingMerchantLogo === 1 ||
                        (_vm.fetchingMerchantLogo === -2 &&
                          _vm.logo.logoPath !== "") ||
                        _vm.merchantLogo !== ""
                          ? _c("div", { staticClass: "header" }, [
                              _c("img", {
                                attrs: {
                                  alt: "",
                                  src: _vm.logoSrc,
                                  width: "300",
                                  height: "76"
                                }
                              })
                            ])
                          : _vm.fetchingMerchantLogo === -1
                          ? _c("div", { staticClass: "fetch-loading" }, [
                              _c(
                                "span",
                                { staticStyle: { "font-size": "3em" } },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-spinner fa-pulse"
                                  })
                                ]
                              )
                            ])
                          : _c("div", { staticClass: "fetch-loading" }),
                        _vm._v(" "),
                        _c("lang-select", { staticClass: "set-language" })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("div", { staticClass: "headline" }, [
                          _vm._v(
                            _vm._s(_vm.headline) +
                              " v" +
                              _vm._s(_vm.versionNumber)
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "userAccount" } },
                          [
                            _c(
                              "span",
                              { staticClass: "svg-container" },
                              [
                                _c("svg-icon", {
                                  attrs: { "icon-class": "user" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("el-input", {
                              ref: "username",
                              attrs: {
                                placeholder: _vm.$t("login.username"),
                                name: "username",
                                type: "text",
                                tabindex: "1",
                                autocomplete: "on"
                              },
                              model: {
                                value: _vm.loginForm.userAccount,
                                callback: function($$v) {
                                  _vm.$set(_vm.loginForm, "userAccount", $$v)
                                },
                                expression: "loginForm.userAccount"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("login.capslockOn"),
                              placement: "right",
                              manual: ""
                            },
                            model: {
                              value: _vm.capsTooltip,
                              callback: function($$v) {
                                _vm.capsTooltip = $$v
                              },
                              expression: "capsTooltip"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "password" } },
                              [
                                _c(
                                  "span",
                                  { staticClass: "svg-container" },
                                  [
                                    _c("svg-icon", {
                                      attrs: { "icon-class": "password" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("el-input", {
                                  key: _vm.passwordType,
                                  ref: "password",
                                  attrs: {
                                    type: _vm.passwordType,
                                    placeholder: _vm.$t("login.password"),
                                    name: "password",
                                    tabindex: "2",
                                    autocomplete: "on"
                                  },
                                  on: {
                                    blur: function($event) {
                                      _vm.capsTooltip = false
                                    }
                                  },
                                  nativeOn: {
                                    keyup: function($event) {
                                      return _vm.checkCapslock($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.loginForm.password,
                                    callback: function($$v) {
                                      _vm.$set(_vm.loginForm, "password", $$v)
                                    },
                                    expression: "loginForm.password"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "show-pwd",
                                    on: { click: _vm.showPwd }
                                  },
                                  [
                                    _c("svg-icon", {
                                      attrs: {
                                        "icon-class":
                                          _vm.passwordType === "password"
                                            ? "eye"
                                            : "eye-open"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              { staticClass: "svg-container" },
                              [
                                _c("svg-icon", {
                                  attrs: { "icon-class": "component" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t("login.authenticator"),
                                name: "lock",
                                tabindex: "2",
                                autocomplete: "on"
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleLogin($event)
                                }
                              },
                              model: {
                                value: _vm.loginForm.verifyCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.loginForm, "verifyCode", $$v)
                                },
                                expression: "loginForm.verifyCode"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.isAdmin
                          ? _c(
                              "div",
                              { staticClass: "captcha" },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "svg-container" },
                                      [
                                        _c("svg-icon", {
                                          attrs: { "icon-class": "example" }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "CAPTCHA",
                                        name: "password",
                                        tabindex: "2",
                                        autocomplete: "on"
                                      },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.handleLogin($event)
                                        }
                                      },
                                      model: {
                                        value: _vm.loginForm.webVerifyCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.loginForm,
                                            "webVerifyCode",
                                            $$v
                                          )
                                        },
                                        expression: "loginForm.webVerifyCode"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "show-pwd" }, [
                                      _c("i", {
                                        staticClass: "el-icon-refresh",
                                        on: { click: _vm.getCode }
                                      })
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: _vm.src === "",
                                        expression: "src === ''"
                                      }
                                    ],
                                    staticClass: "code"
                                  },
                                  [
                                    _c("img", {
                                      attrs: { src: _vm.src, alt: "" }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "rememberMe" },
                          [
                            !_vm.remember
                              ? _c("svg-icon", {
                                  attrs: { "icon-class": "g-checkbox" },
                                  on: {
                                    click: function($event) {
                                      _vm.remember = true
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.remember
                              ? _c("svg-icon", {
                                  attrs: { "icon-class": "g-checkbox-checked" },
                                  on: {
                                    click: function($event) {
                                      _vm.remember = false
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "text" }, [
                              _vm._v(_vm._s(_vm.$t("login.rememberMe")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loading,
                                expression: "loading"
                              }
                            ],
                            attrs: {
                              round: _vm.$store.getters.roundConf,
                              type: "primary",
                              disabled: _vm.loading
                            },
                            nativeOn: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.handleLogin($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("login.logIn")) +
                                "\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }